import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to-sign-up',
  templateUrl: './how-to-sign-up.component.html',
  styleUrls: ['./how-to-sign-up.component.css']
})
export class HowToSignUpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  steps: any[] = [
    {
      icon: 'assets/img/svg/sign-in-line.svg',
      title: 'Click "Sign In"',
      description: 'You\'ll find the button at the top-right of the homepage.'
    },
    {
      icon: 'assets/img/svg/user-follow.svg',
      title: 'Enter Your Econet Mobile Number',
      description: 'This is your gaming ID – no need to remember extra usernames.'
    },
    {
      icon: 'assets/img/svg/chat-check_outline.svg',
      title: 'Verify Your Code',
      description: 'We\'ll send a one-time PIN (OTP) to your phone. Enter it to confirm it\'s you.'
    }
  ];

}
